__turbopack_context__.v({
  "active": "oFCAoa_active",
  "apiVersion": "oFCAoa_apiVersion",
  "badge": "oFCAoa_badge",
  "buttonWrapperAPIKeys": "oFCAoa_buttonWrapperAPIKeys",
  "buttonWrapperLogIn": "oFCAoa_buttonWrapperLogIn",
  "divider": "oFCAoa_divider",
  "dropModal": "oFCAoa_dropModal",
  "dropModalWrapper": "oFCAoa_dropModalWrapper",
  "extraPadding": "oFCAoa_extraPadding",
  "header": "oFCAoa_header",
  "homeLink": "oFCAoa_homeLink",
  "icon": "oFCAoa_icon",
  "leftColumn": "oFCAoa_leftColumn",
  "link": "oFCAoa_link",
  "linkDefault": "oFCAoa_linkDefault",
  "logo": "oFCAoa_logo",
  "logoImage": "oFCAoa_logoImage",
  "logoText": "oFCAoa_logoText",
  "mainNav": "oFCAoa_mainNav",
  "markdownButton": "oFCAoa_markdownButton",
  "name": "oFCAoa_name",
  "navArrows": "oFCAoa_navArrows",
  "navItemWrapper": "oFCAoa_navItemWrapper",
  "navbar": "oFCAoa_navbar",
  "plaidDotCom": "oFCAoa_plaidDotCom",
  "rightColumn": "oFCAoa_rightColumn",
  "row": "oFCAoa_row",
  "search": "oFCAoa_search",
  "sidebar": "oFCAoa_sidebar",
  "sidebarBackdrop": "oFCAoa_sidebarBackdrop",
  "sidebarToggle": "oFCAoa_sidebarToggle",
  "signin": "oFCAoa_signin",
  "team": "oFCAoa_team",
  "text": "oFCAoa_text",
  "wrapper": "oFCAoa_wrapper",
});
